import React, { ChangeEvent, memo } from 'react';
import cls from './TextArea.module.css';
import classNames from 'classnames';

interface TextAreaProps {
    label?: string;
    inputName: string;
    onChange: (name: string, value: string) => void;
    value: string;
    classes?: string;
    maxLength?: number;
    placeholder?: string;
    readOnly?: boolean;
}

export const TextArea = memo(
    ({
        label,
        inputName,
        onChange,
        value,
        classes,
        maxLength = 1000,
        placeholder,
        readOnly = false,
    }: TextAreaProps) => {
        const onInput = (event: ChangeEvent<HTMLTextAreaElement>) => {
            const { name, value } = event.target;
            onChange(name, value);
        };
        return (
            <>
                <label className={classNames(cls.Label, [classes])}>
                    {label}
                    <textarea
                        placeholder={placeholder}
                        maxLength={maxLength}
                        onInput={onInput}
                        className={cls.TextArea}
                        name={inputName}
                        value={value}
                        readOnly={readOnly}
                    />
                </label>
            </>
        );
    }
);
